// Uložení motivu: použít hned, uložit k účtu (platí na všech zařízeních).
import type { MeDTO, Theme } from '@sam/shared';
import { api } from './api';
import { keys, queryClient } from './queries';
import { applyTheme } from './theme';

export async function saveTheme(t: Theme) {
  applyTheme(t);
  queryClient.setQueryData<MeDTO>(keys.me, (old) => (old ? { ...old, theme: t } : old));
  await api('PATCH', '/me', { theme: t });
}
